import { render, staticRenderFns } from "./EiLongFigureScroll2.vue?vue&type=template&id=14bf1fb2&scoped=true&"
import script from "./EiLongFigureScroll2.vue?vue&type=script&lang=js&"
export * from "./EiLongFigureScroll2.vue?vue&type=script&lang=js&"
import style0 from "./EiLongFigureScroll2.vue?vue&type=style&index=0&id=14bf1fb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bf1fb2",
  null
  
)

export default component.exports